import { render, staticRenderFns } from "./serviceStation.vue?vue&type=template&id=f4d37962&"
import script from "./serviceStation.vue?vue&type=script&lang=js&"
export * from "./serviceStation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports